import { render, staticRenderFns } from "./RevisionConf.vue?vue&type=template&id=5d8e1220"
import script from "./RevisionConf.vue?vue&type=script&lang=js"
export * from "./RevisionConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports